















































































































































































































































import { mixins } from 'vue-class-component';
import { Component, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CustomerService } from '@/data/services/customer.service';
import { Login } from 'yellowfin-ui-lib';
import { YFC } from '@/utils/constants';
import { plainToClass } from 'class-transformer';
import StateComponent from '@/mixins/StateComponent';
import SignupSuccess from './SignupSuccess.vue';
import { Address, Cart, Customer, StoreConf } from 'yf-commerce-model-ui-lib';
import { merge } from '@/utils/helpers';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
		SignupSuccess
	}
})
export default class Signup extends mixins(StateComponent) {
	@Inject('CustomerService') customerService!: CustomerService;

	customer!: Customer;
	address!: Address;

	pwdConfirm: string = '';
	flag: any = { flag1: false, flag2: false };

	message: string = '';
	invalidPassword: boolean = false;

	done: boolean = false;

	constructor() {
		super();
		this.customer = new Customer();
		this.address = new Address();
	}

	get validLenght(): boolean {
		return /(?=^.{8,}$)/.test(this.customer.plainpassword);
	}

	get validNumber(): boolean {
		return /(?=.*?[0-9])/.test(this.customer.plainpassword);
	}

	get validUppercaseChar(): boolean {
		return /(?=.*?[A-Z])/.test(this.customer.plainpassword);
	}

	get validTynyChar(): boolean {
		if (this.customer.plainpassword != null)
			return /(?=.*?[a-z])/.test(this.customer.plainpassword);
		return false;
	}

	get validSpecialChar(): boolean {
		return /(?=.*?\W)/.test(this.customer.plainpassword);
	}

	get shopConf(): StoreConf {
		return this.state.shopConf!;
	}

	submit() {
		if ((this.validLenght && this.validNumber && this.validSpecialChar && this.validTynyChar && this.validUppercaseChar) === false) {
			this.invalidPassword = true;
			this.message = this.$t('errors.password-security') as string;
		} else {
			this.invalidPassword = false;
			this.customerService.signup(this.customer, this.address).then(data => {
				const l = new Login();
				l.username = this.customer.email;
				l.password = this.customer.password;
				this.authService.login(l).then(result => {
					this.sendEvent(YFC.EVENT_USER, plainToClass(Customer, result));
					this.replaceCart().then((cart: Cart) => {
						this.sendEvent(YFC.EVENT_CART, cart);
					});
					this.done = true;
				});
			}).catch(({ data }) => {
				this.message = data.msg;
			});
		}
	}

	private async replaceCart(): Promise<Cart> {
		const cart = merge({}, this.state.cart);
		if (cart && !cart.customerid) {
			return this.cartService.replace(cart.opaqueid);
		}
		return Promise.resolve(cart);
	}
}
